import React, { useState, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import Table from "../ui/Table.js";
import filterData from "../control/FilterData.js";
import { readQuizzes, deleteQuiz } from "../control/QuizData.js"; // Assuming you have a deleteQuiz function

function AdminCancel(props) {
  const navigate = useNavigate();
  const [quizzes, setQuizzes] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredQuizzes, setFilteredQuizzes] = useState([]);

  useEffect(() => {
    const fetchQuizzes = async () => {
      const fetchedQuizzes = await readQuizzes();
      setQuizzes(fetchedQuizzes);
    };

    fetchQuizzes();
  }, []);

  useEffect(() => {
    const filtered = quizzes.filter((quiz) =>
      quiz.title.toLowerCase().includes(searchTerm.toLowerCase())
    );
    setFilteredQuizzes(filtered);
  }, [searchTerm, quizzes]);

  const handleCancelQuiz = async (quizId) => {
    const confirmCancel = window.confirm("Are you sure you want to cancel the quiz?");
    if (confirmCancel) {
      await deleteQuiz(quizId); // Call the deleteQuiz function to remove the quiz from the backend or storage
      const fetchedQuizzes = await readQuizzes();
      setQuizzes(fetchedQuizzes);
      setFilteredQuizzes(fetchedQuizzes);
    }
  };

  return (
    <div className="container">
      

      {/* Output quiz data here using a Table */}
      <div className="Profile">
        <h2>Quizzes</h2>
        <div className="d-flex align-items-center mb-3">
        <h2>{props.title}</h2>
        <Form.Control
          type="text"
          placeholder="Search Quizzes"
          style={{ flexGlow: "1", width: "300px" }}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
        <div style={{ flexGrow: 1 }}></div>
          <Button
            variant="success"
            size="m"
            onClick={() => navigate("/faculty/dashboard")}
            style={{ marginRight: "10px" }}
          >
            Back to Dashboard
          </Button>
       
      </div>
        <Table data={filteredQuizzes} selectedItems = {{}} handleDelete={(quizId) => handleCancelQuiz(quizId)} 
         />
      </div>
    </div>
  );
}

export default AdminCancel;
